/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./pages/__root"
import { Route as ThemeRouteImport } from "./pages/theme"
import { Route as SystemSettingsRouteImport } from "./pages/system-settings"
import { Route as SubscriptionRouteImport } from "./pages/subscription"
import { Route as RegisterRouteImport } from "./pages/register"
import { Route as PasswordResetFormRouteImport } from "./pages/password-reset-form"
import { Route as PasswordResetRouteImport } from "./pages/password-reset"
import { Route as MatchesRouteImport } from "./pages/matches"
import { Route as LogoutRouteImport } from "./pages/logout"
import { Route as LoginRouteImport } from "./pages/login"
import { Route as LikesRouteImport } from "./pages/likes"
import { Route as AccountSetupRouteImport } from "./pages/account-setup"
import { Route as AboutRouteImport } from "./pages/about"
import { Route as IndexRouteImport } from "./pages/index"
import { Route as ChatChatIdRouteImport } from "./pages/chat.$chatId"
import { Route as UserUserIdIndexRouteImport } from "./pages/user.$userId.index"
import { Route as UserUserIdEditRouteImport } from "./pages/user.$userId.edit"
import { Route as UserUserIdAccountSettingsRouteImport } from "./pages/user.$userId.account-settings"
import { Route as ProfileMatchIdUidRouteImport } from "./pages/profile.$matchId.$uid"

const ThemeRoute = ThemeRouteImport.update({
  id: "/theme",
  path: "/theme",
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: "/system-settings",
  path: "/system-settings",
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: "/subscription",
  path: "/subscription",
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetFormRoute = PasswordResetFormRouteImport.update({
  id: "/password-reset-form",
  path: "/password-reset-form",
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: "/password-reset",
  path: "/password-reset",
  getParentRoute: () => rootRouteImport,
} as any)
const MatchesRoute = MatchesRouteImport.update({
  id: "/matches",
  path: "/matches",
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: "/logout",
  path: "/logout",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const LikesRoute = LikesRouteImport.update({
  id: "/likes",
  path: "/likes",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSetupRoute = AccountSetupRouteImport.update({
  id: "/account-setup",
  path: "/account-setup",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ChatChatIdRoute = ChatChatIdRouteImport.update({
  id: "/chat/$chatId",
  path: "/chat/$chatId",
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdIndexRoute = UserUserIdIndexRouteImport.update({
  id: "/user/$userId/",
  path: "/user/$userId/",
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdEditRoute = UserUserIdEditRouteImport.update({
  id: "/user/$userId/edit",
  path: "/user/$userId/edit",
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdAccountSettingsRoute =
  UserUserIdAccountSettingsRouteImport.update({
    id: "/user/$userId/account-settings",
    path: "/user/$userId/account-settings",
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileMatchIdUidRoute = ProfileMatchIdUidRouteImport.update({
  id: "/profile/$matchId/$uid",
  path: "/profile/$matchId/$uid",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/account-setup": typeof AccountSetupRoute
  "/likes": typeof LikesRoute
  "/login": typeof LoginRoute
  "/logout": typeof LogoutRoute
  "/matches": typeof MatchesRoute
  "/password-reset": typeof PasswordResetRoute
  "/password-reset-form": typeof PasswordResetFormRoute
  "/register": typeof RegisterRoute
  "/subscription": typeof SubscriptionRoute
  "/system-settings": typeof SystemSettingsRoute
  "/theme": typeof ThemeRoute
  "/chat/$chatId": typeof ChatChatIdRoute
  "/profile/$matchId/$uid": typeof ProfileMatchIdUidRoute
  "/user/$userId/account-settings": typeof UserUserIdAccountSettingsRoute
  "/user/$userId/edit": typeof UserUserIdEditRoute
  "/user/$userId": typeof UserUserIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/account-setup": typeof AccountSetupRoute
  "/likes": typeof LikesRoute
  "/login": typeof LoginRoute
  "/logout": typeof LogoutRoute
  "/matches": typeof MatchesRoute
  "/password-reset": typeof PasswordResetRoute
  "/password-reset-form": typeof PasswordResetFormRoute
  "/register": typeof RegisterRoute
  "/subscription": typeof SubscriptionRoute
  "/system-settings": typeof SystemSettingsRoute
  "/theme": typeof ThemeRoute
  "/chat/$chatId": typeof ChatChatIdRoute
  "/profile/$matchId/$uid": typeof ProfileMatchIdUidRoute
  "/user/$userId/account-settings": typeof UserUserIdAccountSettingsRoute
  "/user/$userId/edit": typeof UserUserIdEditRoute
  "/user/$userId": typeof UserUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/account-setup": typeof AccountSetupRoute
  "/likes": typeof LikesRoute
  "/login": typeof LoginRoute
  "/logout": typeof LogoutRoute
  "/matches": typeof MatchesRoute
  "/password-reset": typeof PasswordResetRoute
  "/password-reset-form": typeof PasswordResetFormRoute
  "/register": typeof RegisterRoute
  "/subscription": typeof SubscriptionRoute
  "/system-settings": typeof SystemSettingsRoute
  "/theme": typeof ThemeRoute
  "/chat/$chatId": typeof ChatChatIdRoute
  "/profile/$matchId/$uid": typeof ProfileMatchIdUidRoute
  "/user/$userId/account-settings": typeof UserUserIdAccountSettingsRoute
  "/user/$userId/edit": typeof UserUserIdEditRoute
  "/user/$userId/": typeof UserUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/about"
    | "/account-setup"
    | "/likes"
    | "/login"
    | "/logout"
    | "/matches"
    | "/password-reset"
    | "/password-reset-form"
    | "/register"
    | "/subscription"
    | "/system-settings"
    | "/theme"
    | "/chat/$chatId"
    | "/profile/$matchId/$uid"
    | "/user/$userId/account-settings"
    | "/user/$userId/edit"
    | "/user/$userId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/about"
    | "/account-setup"
    | "/likes"
    | "/login"
    | "/logout"
    | "/matches"
    | "/password-reset"
    | "/password-reset-form"
    | "/register"
    | "/subscription"
    | "/system-settings"
    | "/theme"
    | "/chat/$chatId"
    | "/profile/$matchId/$uid"
    | "/user/$userId/account-settings"
    | "/user/$userId/edit"
    | "/user/$userId"
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/account-setup"
    | "/likes"
    | "/login"
    | "/logout"
    | "/matches"
    | "/password-reset"
    | "/password-reset-form"
    | "/register"
    | "/subscription"
    | "/system-settings"
    | "/theme"
    | "/chat/$chatId"
    | "/profile/$matchId/$uid"
    | "/user/$userId/account-settings"
    | "/user/$userId/edit"
    | "/user/$userId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountSetupRoute: typeof AccountSetupRoute
  LikesRoute: typeof LikesRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  MatchesRoute: typeof MatchesRoute
  PasswordResetRoute: typeof PasswordResetRoute
  PasswordResetFormRoute: typeof PasswordResetFormRoute
  RegisterRoute: typeof RegisterRoute
  SubscriptionRoute: typeof SubscriptionRoute
  SystemSettingsRoute: typeof SystemSettingsRoute
  ThemeRoute: typeof ThemeRoute
  ChatChatIdRoute: typeof ChatChatIdRoute
  ProfileMatchIdUidRoute: typeof ProfileMatchIdUidRoute
  UserUserIdAccountSettingsRoute: typeof UserUserIdAccountSettingsRoute
  UserUserIdEditRoute: typeof UserUserIdEditRoute
  UserUserIdIndexRoute: typeof UserUserIdIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/theme": {
      id: "/theme"
      path: "/theme"
      fullPath: "/theme"
      preLoaderRoute: typeof ThemeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/system-settings": {
      id: "/system-settings"
      path: "/system-settings"
      fullPath: "/system-settings"
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/subscription": {
      id: "/subscription"
      path: "/subscription"
      fullPath: "/subscription"
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/register": {
      id: "/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/password-reset-form": {
      id: "/password-reset-form"
      path: "/password-reset-form"
      fullPath: "/password-reset-form"
      preLoaderRoute: typeof PasswordResetFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/password-reset": {
      id: "/password-reset"
      path: "/password-reset"
      fullPath: "/password-reset"
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/matches": {
      id: "/matches"
      path: "/matches"
      fullPath: "/matches"
      preLoaderRoute: typeof MatchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/logout": {
      id: "/logout"
      path: "/logout"
      fullPath: "/logout"
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/likes": {
      id: "/likes"
      path: "/likes"
      fullPath: "/likes"
      preLoaderRoute: typeof LikesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account-setup": {
      id: "/account-setup"
      path: "/account-setup"
      fullPath: "/account-setup"
      preLoaderRoute: typeof AccountSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about": {
      id: "/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/chat/$chatId": {
      id: "/chat/$chatId"
      path: "/chat/$chatId"
      fullPath: "/chat/$chatId"
      preLoaderRoute: typeof ChatChatIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/user/$userId/": {
      id: "/user/$userId/"
      path: "/user/$userId"
      fullPath: "/user/$userId"
      preLoaderRoute: typeof UserUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/user/$userId/edit": {
      id: "/user/$userId/edit"
      path: "/user/$userId/edit"
      fullPath: "/user/$userId/edit"
      preLoaderRoute: typeof UserUserIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/user/$userId/account-settings": {
      id: "/user/$userId/account-settings"
      path: "/user/$userId/account-settings"
      fullPath: "/user/$userId/account-settings"
      preLoaderRoute: typeof UserUserIdAccountSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/$matchId/$uid": {
      id: "/profile/$matchId/$uid"
      path: "/profile/$matchId/$uid"
      fullPath: "/profile/$matchId/$uid"
      preLoaderRoute: typeof ProfileMatchIdUidRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountSetupRoute: AccountSetupRoute,
  LikesRoute: LikesRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  MatchesRoute: MatchesRoute,
  PasswordResetRoute: PasswordResetRoute,
  PasswordResetFormRoute: PasswordResetFormRoute,
  RegisterRoute: RegisterRoute,
  SubscriptionRoute: SubscriptionRoute,
  SystemSettingsRoute: SystemSettingsRoute,
  ThemeRoute: ThemeRoute,
  ChatChatIdRoute: ChatChatIdRoute,
  ProfileMatchIdUidRoute: ProfileMatchIdUidRoute,
  UserUserIdAccountSettingsRoute: UserUserIdAccountSettingsRoute,
  UserUserIdEditRoute: UserUserIdEditRoute,
  UserUserIdIndexRoute: UserUserIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
